export default __webpack_public_path__ + "static/media/value_gap.fc672252.png";